'use es6';

export const PROPERTY_RECORD = 'PROPERTY_RECORD';
export const REFERENCE_RECORD = 'REFERENCE_RECORD';